<script>export let show = false;
</script>

<div class="loading-container" class:show>
  <slot />
</div>

<style>.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  justify-content: center;
  align-items: center;
  display: none;
  z-index: var(--z4);
}
.loading-container.show {
  display: flex;
}</style>
